import { getTelLinkFromPhone } from "./getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "./getWhatsappLinkFromPhone";

export function getContact(component) {
  const contact = [];

  if (component.informations.tel) {
    let telSplit = component.informations.tel.split(";");

    if (Array.isArray(telSplit)) {
      let tel = [];
      telSplit.forEach(function (val) {
        let text = val.replace("(", "<small>").replace(")", "</small>");

        tel.push({
          title: text,
          link: getTelLinkFromPhone(val),
          target: "_self",
          icon: "fa-phone-alt",
          size: 16,
        });
      });

      contact.push(tel);
    } else {
      let text = component.informations.tel
        .replace("(", "<small>")
        .replace(")", "</small>");

      contact.push({
        title: text,
        link: getTelLinkFromPhone(component.informations.tel),
        target: "_self",
        icon: "fa-phone-alt",
        size: 16,
      });
    }
  }

  if (component.informations.whatsapp) {
    let whatsappSplit = component.informations.whatsapp.split(";");

    if (Array.isArray(whatsappSplit)) {
      let whatsapp = [];
      whatsappSplit.forEach(function (val) {
        let text = val.replace("(", "<small>").replace(")", "</small>");

        whatsapp.push({
          title: text,
          link: getWhatsappLinkFromPhone(val),
          target: "_blank",
          icon: "fa-whatsapp",
          size: 20,
        });
      });

      contact.push(whatsapp);
    } else {
      let text = component.informations.whatsapp
        .replace("(", "<small>")
        .replace(")", "</small>");

      contact.push({
        title: text,
        link: getWhatsappLinkFromPhone(component.informations.whatsapp),
        target: "_blank",
        icon: "fa-whatsapp",
        size: 20,
      });
    }
  }

  if (component.informations.email) {
    let emailSplit = component.informations.email.split(";");

    if (Array.isArray(emailSplit)) {
      let email = [];
      emailSplit.forEach(function (val) {
        email.push({
          title: val,
          link: "mailto:" + val,
          target: "_self",
          icon: "far fa-envelope",
          size: 18,
        });
      });

      contact.push(email);
    } else {
      contact.push({
        title: component.informations.email,
        link: "mailto:" + component.informations.email,
        target: "_self",
        icon: "far fa-envelope",
        size: 18,
      });
    }
  }

  if (component.informations.address)
    contact.push({
      title: component.informations.address,
      link: component.informations.google_maps,
      target: "_blank",
      icon: "fa-map-marker-alt",
      size: 18,
    });

  return contact;
}
